import React from 'react'

import { useTranslation } from 'language/translator'

import Box from 'components_new/atoms/Box'
import Button from 'components_new/atoms/Button'
import Icon from 'components_new/atoms/Icon'
import Link from 'components_new/atoms/Link'

interface Props {
  createDisabled?: boolean
  creating: boolean
  stepsCount: number
  activeStep: number
  metricSelected: boolean
  onCreate: () => void
  onClose: () => void
  onChangeStep: (step: number) => void
}

const Actions = ({
  createDisabled,
  creating,
  stepsCount,
  activeStep,
  metricSelected,
  onCreate,
  onClose,
  onChangeStep
}: Props) => {
  const { t } = useTranslation()

  if (!metricSelected) {
    return (
      <Button onClick={onClose} variant="text">
        {t('global', 'cancel')}
      </Button>
    )
  }

  const isLastStep = stepsCount > 0 && activeStep === stepsCount - 1

  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}
    >
      <Box sx={{ display: 'flex', flex: 1, justifyContent: 'flex-start' }}>
        <Button
          disabled={creating}
          onClick={() => onChangeStep(-1)}
          variant="text"
        >
          {t('global', 'cancel')}
        </Button>
      </Box>

      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flex: 1,
          justifyContent: 'center'
        }}
      >
        <Link disabled={creating || createDisabled} onClick={onCreate}>
          <Icon name="Bolt" sx={{ fontSize: '1em', verticalAlign: 'middle' }} />{' '}
          {t('metrics', 'skip_and_add_default')}
        </Link>
      </Box>

      <Box sx={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
        <Button
          disabled={creating}
          onClick={() => onChangeStep(activeStep - 1)}
          variant="text"
        >
          {t('global', 'previous')}
        </Button>
        <Button
          disabled={isLastStep && createDisabled}
          loading={creating}
          onClick={isLastStep ? onCreate : () => onChangeStep(activeStep + 1)}
        >
          {isLastStep ? t('global', 'add') : t('global', 'next')}
        </Button>
      </Box>
    </Box>
  )
}

export default Actions
